module.exports = __webpack_public_path__ + "img/4.e7247cd0.svg";